import { useCallback, useState } from "react";

const getProvider = () => {
  if (typeof global !== "undefined" && global.sessionStorage) {
    return global.sessionStorage;
  }
  if (typeof globalThis !== "undefined" && globalThis.sessionStorage) {
    return globalThis.sessionStorage;
  }
  if (typeof window !== "undefined" && window.sessionStorage) {
    return window.sessionStorage;
  }
  if (typeof sessionStorage !== "undefined") {
    return sessionStorage;
  }
  return null;
};

const createStorage = (provider: any) => ({
  get(key: any, defaultValue: any) {
    const json = provider.getItem(key);
    if (json === null || json === "null" || typeof json === "undefined") {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    }

    const parsed = JSON.parse(json);

    if (parsed.date === null || parsed.date >= Date.now()) {
      return parsed.value;
    }
    return typeof defaultValue === "function" ? defaultValue() : defaultValue;
  },
  set(key: any, value: any, cacheDuration: any) {
    try {
      provider.setItem(
        key,
        JSON.stringify({
          date: cacheDuration ? Date.now() + cacheDuration * 1000 : null,
          value,
        })
      );
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  },
  clear() {
    provider.clear();
  },
});
export const storage = createStorage(getProvider());

type PersistentSetStateType<T> = (newState: T | ((oldState: T) => T)) => void;
type UsePersistedStateReturnType<T> = [T, PersistentSetStateType<T>]; // Ideally, T should

const usePersistedState = <T,>(
  initialState: T,
  key: string,
  cacheDuration: any
): UsePersistedStateReturnType<T> => {
  if (key && cacheDuration) {
    // TODO use the key and the cacheDuration
  }
  /* const [state, setState] = useState(initialState);
  return [state, setState]; */
  const [state, setState] = useState<T>(() => storage.get(key, initialState));

  const persistentSetState: PersistentSetStateType<T> = useCallback(
    (newState) => {
      setState((oldState: T) => {
        const newStateValue =
          typeof newState === "function"
            ? (newState as (oldState: T) => T)(oldState)
            : newState;

        storage.set(key, newStateValue, cacheDuration);
        return newStateValue;
      });
    },
    [key, cacheDuration]
  );

  return [state, persistentSetState];
};

export default usePersistedState;
